import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui'
import { useDeportes } from '../../../hooks/useDeportes'

const ESTADO = {
  abierta: { label: 'Abierta', cls: 'bg-green-100 text-green-700' },
  cerrada: { label: 'Cerrada', cls: 'bg-muted text-muted-foreground' },
  planeada: { label: 'Planeada', cls: 'bg-amber-100 text-amber-700' },
}

const EstadoBadge = ({ estado }) => {
  const e = ESTADO[estado]
  if (!e) return null
  return <span className={`shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-medium leading-none ${e.cls}`}>{e.label}</span>
}

const TemporadaSelector = ({ temporadas, value, onChange, className = '' }) => {
  const { label: deporteLabel } = useDeportes()
  if (!temporadas.length) return null

  const selected = temporadas.find((t) => t.id === value)
  const itemText = (t) => `${t.nombre}${t.deporte_id ? ` · ${deporteLabel(t.deporte_id)}` : ''}`

  return (
    <Select value={value || ''} onValueChange={onChange}>
      <SelectTrigger className={`w-auto min-w-[13rem] max-w-full ${className}`}>
        {selected ? (
          <span className="flex min-w-0 items-center gap-2">
            <span className="truncate">{selected.nombre}</span>
            <EstadoBadge estado={selected.estado} />
          </span>
        ) : (
          <SelectValue placeholder="Seleccionar temporada" />
        )}
      </SelectTrigger>
      {/* Sin el max-w el desplegable crece con el texto mas largo ("Primavera 2026
          Tackle Demo · Tackle Football") y se sale de la pantalla en movil. */}
      <SelectContent className="max-w-[calc(100vw-2rem)]">
        {temporadas.map((t) => (
          <SelectItem key={t.id} value={t.id}>
            <span className="flex min-w-0 items-center gap-2">
              <span className="truncate">{itemText(t)}</span>
              <EstadoBadge estado={t.estado} />
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default TemporadaSelector
